import React from 'react';

import {useI18n} from '../../../../../data/hooks/i18nHooks';
import ButtonLink from '../../../../elements/ButtonLink';

const AppointmentButton = props => {
    const {event, question, answer} = props,
        i18n = useI18n();

    return (
        <ButtonLink
            type="button"
            className="buttonlink smallButton marginTop marginRight"
            href={'./invite?users=' + answer.answerer_id}
            style={{
                ...event._local.styles.smallButton,
                width: 'auto',
                display: 'inline-block',
            }}>
            {i18n['label.appointment']}
        </ButtonLink>
    );
};

export default AppointmentButton;
